var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "b-jumbotron",
        { staticStyle: { padding: "0" } },
        [
          _c("template", { slot: "lead" }, [
            _c("h6", [
              _vm._v(
                "Training Booking File Uploading (Max 7 Files, PDF ONLY !) "
              )
            ])
          ]),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-input-group",
                    [
                      _c(
                        "b-dropdown",
                        {
                          attrs: {
                            slot: "prepend",
                            text: !!_vm.fileDirectory
                              ? _vm.fileDirectory
                              : "File Directory",
                            variant: "dark"
                          },
                          slot: "prepend"
                        },
                        _vm._l(_vm.fileDirectoryOptions, function(item, index) {
                          return _c(
                            "b-dropdown-item",
                            {
                              key: index,
                              on: {
                                click: function($event) {
                                  _vm.changeFileDirectory(item, $event.target)
                                }
                              },
                              model: {
                                value: _vm.fileDirectory,
                                callback: function($$v) {
                                  _vm.fileDirectory = $$v
                                },
                                expression: "fileDirectory"
                              }
                            },
                            [_vm._v(_vm._s(item))]
                          )
                        })
                      ),
                      _c("b-form-file", {
                        ref: "trainingFileInput",
                        staticStyle: { overflow: "hidden" },
                        attrs: {
                          state: !!_vm.pdfFile,
                          multiple: "",
                          variant: "success",
                          accept: ".pdf",
                          placeholder: !!_vm.fileDirectory
                            ? "File Will Submit As " +
                              _vm.fileDirectory +
                              " Document, PDF File Only"
                            : "Please Select File Directory"
                        },
                        model: {
                          value: _vm.pdfFile,
                          callback: function($$v) {
                            _vm.pdfFile = $$v
                          },
                          expression: "pdfFile"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            { staticClass: "selected-file-box" },
            [
              !!_vm.pdfFile
                ? _c(
                    "b-col",
                    { attrs: { sm: "" } },
                    [
                      _c(
                        "b-alert",
                        { attrs: { variant: "primary", show: "" } },
                        [
                          _c("strong", [
                            _vm._v("Training Booking Related File:")
                          ]),
                          _c(
                            "ul",
                            _vm._l(_vm.pdfFile, function(p) {
                              return _c("li", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(p.name) +
                                    "\n            "
                                )
                              ])
                            })
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          !!_vm.pdfFile
            ? _c(
                "b-row",
                { staticClass: "selected-file-box" },
                [
                  _c(
                    "b-col",
                    { staticStyle: { padding: "0 5px" }, attrs: { sm: "2" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-success" },
                          on: {
                            click: function($event) {
                              _vm.uploadTrainingFiles()
                            }
                          }
                        },
                        [_vm._v("\n            Upload Files\n          ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { sm: "3" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "danger" },
                          on: { click: _vm.resetSelectedFiles }
                        },
                        [_vm._v("\n            Reset Selected\n          ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-034f82ed", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-034f82ed","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/mainPage/bookModuleSession/UploadFilePanel.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-034f82ed","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/mainPage/bookModuleSession/UploadFilePanel.vue
// module chunks = 0 5 8 12